import { Icon } from '@openeducation/oe-rn-components';
import React from 'react';
import { StyleSheet, View } from 'react-native';

import { useColors } from '../../../hooks/lesson-player.context';
import ThemedText2 from '../../themed-text-2';
import { LessonSlideStatus } from '../lesson-slide-status.enum';

interface LessonIndexItemProps {
  number: string | number;
  isCurrent?: boolean;
  status: LessonSlideStatus;
}

export function LessonIndexItemNumber({
  number,
  isCurrent = false,
  status = LessonSlideStatus.LOCKED,
}: LessonIndexItemProps) {
  const colors = useColors();

  if (status === LessonSlideStatus.COMPLETED) {
    const backgroundColor = isCurrent ? colors.primary : colors.silverGray;
    return (
      <View style={[styles.smallCircle, { backgroundColor }]}>
        <Icon type="solid" color={colors.background} size={12} name="check" />
      </View>
    );
  }

  const textColor = isCurrent ? colors.background : colors.silverGray;
  const backgroundColor = isCurrent ? colors.primary : colors.grayLight;

  return (
    <View style={[styles.bigCircle, { backgroundColor }]}>
      <ThemedText2
        fontSize={16}
        fontWeightStyle="bold"
        style={{ color: textColor }}
      >
        {number}
      </ThemedText2>
    </View>
  );
}

const styles = StyleSheet.create({
  smallCircle: {
    width: 24,
    height: 24,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 16,
    marginLeft: 4,
  },
  bigCircle: {
    width: 32,
    height: 32,
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
});
